exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb .custom-checkbox{top:-32px!important;position:relative}.cb>label{margin-left:30px!important}", ""]);

// exports
